<svg class="color" [attr.width]="width" [attr.height]="height" [ngStyle]="style" >
    <use [attr.href]="url"></use>
</svg>   